<script setup lang="ts">
const { data: promotions, error: promotionError } = await useFetch(
  "/api/menu/sidebar/getSidebarSecondaryMenuItems"
)
</script>
<template>
  <div v-if="!promotionError">
    <AtomsSecondaryMenuItem
      v-for="promotion in promotions"
      :promotion="promotion"
    />
  </div>
</template>
